import { Tabs, Tab } from "@heroui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * View toggle component for switching between individual and team views using routes
 * @returns {React.ReactElement} View toggle tabs
 */
export default function ViewToggle() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentView = location.pathname === "/feed" ? "team" : "individual";

  const handleViewChange = (key) => {
    if (key === "team") {
      navigate("/feed");
    } else {
      navigate("/");
    }
  };

  return (
    <Tabs
      selectedKey={currentView}
      onSelectionChange={handleViewChange}
      size="sm"
      variant="light"
      aria-label="View toggle"
    >
      <Tab key="individual" title="My Week" />
      <Tab key="team" title="Team Feed" />
    </Tabs>
  );
}
